module.exports = __webpack_public_path__ + "media/images/mobile/products/bg-428c81a6e654ddacedc4fc602f2b9d8a.jpg";